var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "51px",
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/information/purple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "8.-V3-Reports---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "are-you-sure-modal-for-removing-media",
    transform: "translate(-678.000000, -391.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(475.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/information/purple",
    transform: "translate(204.666667, 49.224138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c-info-(1)",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#5C59BC",
    fillRule: "nonzero",
    cx: 23.3333333,
    cy: 33.6666667,
    r: 3.33333333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#5C59BC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 23.3333333,
    cy: 23.3333333,
    r: 23.3333333
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.3333333,
    y1: 23.6666667,
    x2: 23.3333333,
    y2: 10.3333333,
    id: "Path",
    stroke: "#5C59BC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.47e23101425ce7ab6455e955b78b704a.svg";
export { ForwardRef as ReactComponent };